import React from 'react';
import { Box, Typography, List, ListItem, useTheme } from '@mui/material';
import { useDropzone } from 'react-dropzone';

const FileUpload = ({ onDrop, uploadedFiles }) => {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': ['.pdf'],
            'application/msword': ['.doc', '.docx'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
        },
        multiple: true,
        maxSize: 5 * 1024 * 1024,
    });

    const theme = useTheme();

    return (
        <Box>
        <Box
            {...getRootProps()}
            sx={{
            padding: 2, // 16px
            backgroundColor: theme.palette.primary.main, // use primary main color
            textAlign: 'center',
            height: 50,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 2, // 8px
            cursor: 'pointer',
            marginBottom: 1, // 8px
            '&:hover': {
                backgroundColor: theme.palette.primary.dark, // a darker shade on hover
            },
            }}
        >
            <input {...getInputProps()} />
            <Typography
            sx={{
                color: theme.palette.text.opposite,
                fontFamily: theme.typography.fontFamily, // your custom font family
                userSelect: 'none',
            }}
            >
            Drag & drop files here, or click to select (PDF/Word)
            </Typography>
        </Box>

        {uploadedFiles && uploadedFiles.length > 0 && (
            <List dense sx={{ fontFamily: theme.typography.fontFamily, color: theme.palette.text.primary }}>
            {uploadedFiles.map((file, idx) => (
                <ListItem key={idx} disablePadding>
                {/* You can add an icon here if you want */}
                {file.name}
                </ListItem>
            ))}
            </List>
        )}
        </Box>
    );
};

export default FileUpload;
